export const GET_STORE_GROUPS = 'GET_STORE_GROUPS';
export const GET_STORE_GROUP = 'GET_STORE_GROUP';
export const CREATE_STORE_GROUP = 'CREATE_STORE_GROUP';
export const DELETE_STORE_GROUP = 'DELETE_STORE_GROUP';
export const UPDATE_STORE_GROUP = 'UPDATE_STORE_GROUP';
